
import { defineComponent } from 'vue'
import Footer from '@/components/base/Footer.vue'
import Header from '@/components/base/Header.vue'
import Iframe from '@/components/base/Iframe.vue'

export default defineComponent({
  name: 'Contact',
  components: {
    Header,
    Footer,
    Iframe
  }
})

